module.exports = __webpack_public_path__ + "static/media/priontoFull.3b2bc36c.png";